import { useCallback, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Dialog, DialogContent, Grid, Paper, Typography, Tooltip, Chip } from '@material-ui/core'
import VisibilityIcon from '@material-ui/icons/VisibilityOutlined'
import CustomTable from '../../../components/CustomTable/CustomTable'
import { getModifiedProducts } from '../../../api/productModification.service'
import { useDispatch, useSelector } from 'react-redux'
import ModifiedProductDetails from './ModifiedProductDetails'
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined'
import ErrorOutlinedIcon from '@material-ui/icons/ErrorOutlined'
import CheckCircleIcon from '@material-ui/icons/CheckCircleOutlined'
import EditIcon from '@material-ui/icons/EditOutlined'
import ProductForm from '../ProductForm'
import { formatDate } from '../../../common/utils'
import { toggleModalFullscreen } from '../../../redux/features/modalSlice'

const stateData = {
  RevisionAdministrador: {
    id: 0,
    title: 'Revisión Conway',
    color: '#ffc107',
    icon: <AccessTimeOutlinedIcon style={{ color: 'white' }} />
  },
  RevisionProveedor: {
    id: 1,
    title: 'Revisión Proveedor',
    color: '#ff1744',
    icon: <ErrorOutlinedIcon style={{ color: 'white' }} />
  },
  Confirmado: {
    id: 2,
    title: 'Confirmado',
    color: '#4dbd74',
    icon: <CheckCircleIcon style={{ color: 'white' }} />
  }
}

const ModifiedProductsView = () => {
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [isModalDetailOpen, setIsModalDetailOpen] = useState(false)
  const [isModalFormOpen, setIsModalFormOpen] = useState(false)
  const [state, setState] = useState({
    data: [],
    columns: [],
    loading: false,
    pages: 0,
    page: 0,
    pageSize: 15,
    sorted: null,
    filtered: [],
    createModal: true,
    hasChanges: true
  })
  const providerSelected = useSelector((state) => state.provider)
  const modal = useSelector((state) => state.modal)
  const dispatch = useDispatch()

  const [tableLoading, setTableLoading] = useState(true)

  const handleSetState = (values) => {
    const newState = { ...state, ...values, hasChanges: true }
    setState(newState)
  }

  const getData = useCallback(
    (nState) => {
      setTableLoading(true)
      const postObject = {
        providerId: providerSelected.id,
        ...(nState ? nState : state)
      }
      const data = JSON.stringify(postObject)
      getModifiedProducts(data)
        .then(({ data }) => {
          setState({
            ...state,
            page: postObject.page,
            sorted: postObject.sorted,
            filtered: postObject.filtered,
            pageSize: postObject.pageSize,
            data: data.results,
            pages: data.pageCount,
            hasChanges: false
          })
          setTableLoading(false)
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    [providerSelected.id, state]
  )

  const generateColumns = useCallback(() => {
    setState({
      ...state,
      columns: [
        {
          Header: 'Fecha creación',
          accessor: 'creationDate',
          filterable: true,
          sortable: true,
          idSort: 'startDate',
          Cell: (props) => <span style={{ float: 'left' }}>{formatDate(props.value)}</span>
        },
        {
          Header: 'Código artículo',
          accessor: 'articleCode',
          filterable: true,
          sortable: true,
          idSort: 'id',
          Cell: (props) => <span style={{ float: 'right' }}>{props.value}</span>
        },
        {
          Header: 'Cód. Art. Proveedor',
          accessor: 'providerArticleCode',
          filterable: true,
          sortable: true,
          Cell: (props) => <span style={{ float: 'right' }}>{props.value}</span>
        },
        {
          Header: 'Descripción',
          accessor: 'description',
          filterable: true,
          sortable: true,
          Cell: (props) => <span style={{ float: 'left' }}>{props.value}</span>
        },
        {
          Header: 'Estado',
          accessor: 'state',
          filterable: true,
          sortable: true,
          Cell: (props) => (
            <Chip
              size="small"
              avatar={stateData[props.value].icon}
              style={{
                backgroundColor: stateData[props.value].color,
                color: 'white',
                float: 'right'
              }}
              label={stateData[props.value].title}
            />
          )
        },
        {
          Header: '',
          accessor: 'details',
          sortable: false,
          Cell: (props) => (
            <span>
              <Tooltip title="Ver detalle del artículo">
                <VisibilityIcon
                  onClick={(e) => handleClickDetails(e, props.row.original.id)}
                  height="25"
                  width="25"
                  style={{
                    cursor: 'pointer',
                    float: 'left',
                    marginLeft: '10px'
                  }}
                />
              </Tooltip>
            </span>
          ),
          width: 45
        },
        {
          Header: '',
          accessor: 'edit',
          sortable: false,
          Cell: (props) => (
            <span>
              {props.row.original.state !== 'Confirmado' ? (
                <Tooltip title="Editar artículo">
                  <EditIcon
                    onClick={(e) => handleClickEdit(e, props.row.original.id)}
                    height="25"
                    width="25"
                    style={{
                      cursor: 'pointer',
                      float: 'left',
                      marginLeft: '10px'
                    }}
                  />
                </Tooltip>
              ) : (
                <Tooltip
                  title={
                    props.row.original.state === 'Confirmado'
                      ? 'No se puede editar un artículo aprobado.'
                      : 'No se puede editar mientras este en revisión por parte de administración.'
                  }
                >
                  <EditIcon
                    height="25"
                    width="25"
                    style={{
                      color: 'grey',
                      float: 'left',
                      marginLeft: '10px'
                    }}
                  />
                </Tooltip>
              )}
            </span>
          ),
          width: 45
        }
      ]
    })
  }, [state])

  useEffect(() => {
    if (state.hasChanges && state.columns.length > 0) getData()
  }, [getData, state.hasChanges])

  useEffect(() => {
    if (Object.entries(state.columns).length === 0) generateColumns()
  }, [state.columns, generateColumns])

  const handleClickDetails = (e, id) => {
    setSelectedProduct(id)
    setIsModalDetailOpen(true)
  }

  const fetchData = (nState) => {
    getData(nState)
  }

  const handleCloseModalDetail = () => {
    setIsModalDetailOpen(false)
  }

  const handleClickEdit = (e, id) => {
    setSelectedProduct(id)
    setIsModalFormOpen(true)
  }

  const handleCloseModalForm = () => {
    setIsModalFormOpen(false)
  }

  const exitFullscreenModal = useCallback(() => {
    if (!isModalDetailOpen && !isModalFormOpen && modal.showFullscreenOption) {
      dispatch(toggleModalFullscreen(false))
    }
  }, [isModalDetailOpen, isModalFormOpen, modal.showFullscreenOption, dispatch])

  useEffect(() => {
    let timeout = setTimeout(exitFullscreenModal, 500)
    return () => clearTimeout(timeout)
  }, [isModalDetailOpen, isModalFormOpen, exitFullscreenModal])

  return (
    <Paper style={{ padding: 16 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography color="secondary">ARTÍCULOS MODIFICADOS</Typography>
        </Grid>
        <Grid item xs={12}>
          {state.loading ? (
            <p>
              <em>Cargando...</em>
            </p>
          ) : (
            <CustomTable
              {...state}
              numButtonColumns={0}
              tableLoading={tableLoading}
              fetchData={fetchData}
              handleSetState={handleSetState}
              filterProps={[
                { width: 45, maxWidth: 45 },
                { placeholder: 'Filtrar id...', id: 'id', value: '', width: 150 },
                {
                  placeholder: 'Filtrar código...',
                  id: 'providerArticleCode',
                  value: '',
                  width: 150
                },
                { placeholder: 'Filtrar descripción...', id: 'description', value: '', width: 150 },
                {
                  placeholder: 'Filtrar estado...',
                  id: 'state',
                  value: '',
                  options: [
                    { label: stateData.RevisionAdministrador.title, value: '0' },
                    { label: stateData.RevisionProveedor.title, value: '1' },
                    { label: stateData.Confirmado.title, value: '2' },
                    { label: 'Todos', value: '' }
                  ]
                },
                { width: 45, maxWidth: 45 },
                { width: 45, maxWidth: 45 }
              ]}
              manualSortBy={true}
            />
          )}
        </Grid>
      </Grid>
      <Dialog
        open={isModalDetailOpen}
        onClose={handleCloseModalDetail}
        maxWidth={'md'}
        fullWidth={true}
        fullScreen={modal.isFullscreen}
      >
        <DialogContent>
          <ModifiedProductDetails id={selectedProduct} onClose={handleCloseModalDetail} />
        </DialogContent>
      </Dialog>
      <Dialog
        open={isModalFormOpen}
        onClose={handleCloseModalForm}
        maxWidth={'md'}
        fullWidth={true}
        fullScreen={modal.isFullscreen}
      >
        <DialogContent>
          <ProductForm
            id={selectedProduct}
            onClose={handleCloseModalForm}
            onSave={getData}
            isModification={true}
          />
        </DialogContent>
      </Dialog>
    </Paper>
  )
}

export default withRouter(ModifiedProductsView)
ModifiedProductsView.displayName = 'Artículos Modificados'
